export const DEBIT_OR_CREDIT_CARD_ID = "--debit-or-credit-card--"

export const PAYMENT_OBJECT_TYPE_INVOICE = "invoice"
export const PAYMENT_OBJECT_TYPE_ONE_TIME_PAYMENT = "oneTimePayment"
export const PAYMENT_OBJECT_TYPE_PAYEE_ORDER = "payeeOrder"